import { ExternalLink } from "lucide-react";
import { useAppTranslation } from "@/i18n/useAppTranslation";

const DRIVESHARE_EVENTS_LOGO_URL =
  "https://events.driveshare.com/lovable-uploads/e5d1f848-804e-441b-b013-9a983dfb1978.png";

export function DashboardEventsBanner() {
  const { t } = useAppTranslation();
  return (
    <a
      href="https://events.driveshare.com"
      target="_blank"
      rel="noopener noreferrer"
      className="group block overflow-hidden rounded-2xl border border-border shadow-sm transition hover:shadow-md"
      data-testid="dashboard-events-banner"
    >
      <div
        className="relative px-6 py-10 sm:px-8 sm:py-12"
        style={{
          backgroundImage: `url(/images/events-banner-bg.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 max-w-2xl">
          <img
            src={DRIVESHARE_EVENTS_LOGO_URL}
            alt={t("dashboard.eventsBanner.logoAlt", "DRIVESHARE Events")}
            className="h-9 w-auto drop-shadow-md sm:h-10"
            loading="lazy"
            decoding="async"
          />
          <h3 className="mt-3 font-sans text-2xl font-bold leading-tight text-white drop-shadow-md sm:text-3xl">
            {t("dashboard.eventsBanner.title", "Discover & share local classic car events")}
          </h3>
          <p className="mt-3 text-sm leading-relaxed text-white/90 drop-shadow-sm sm:text-base">
            {t("dashboard.eventsBanner.desc", "Browse upcoming shows, rallies, and meetups near you, or submit your own event to reach thousands of classic car enthusiasts.")}
          </p>
          <span className="mt-5 inline-flex items-center gap-2 rounded-lg bg-white px-5 py-2.5 text-sm font-semibold text-brand shadow transition group-hover:bg-white/90">
            {t("dashboard.eventsBanner.cta", "Explore events")}
            <ExternalLink className="h-4 w-4" />
          </span>
        </div>
      </div>
    </a>
  );
}
